<div style="margin:0 20px;">
  <p-card>
    <div class="card-body">
      <app-view *ngIf="create" [info]="create" [items]="create?.data?.content" [data]="create_data"></app-view>
    </div>
  </p-card>
  <button pButton severity="primary" (click)="createData(data.type)" *ngIf="!hasErrors() && !created">Create</button>
</div>
